import moment from "moment";
import enLang from "./entries/en";
import plLang from "./entries/pl";
import esLang from "./entries/es";
import {addLocaleData} from "react-intl";

const AppLocale = {
  en: enLang,
  pl: plLang,
  es: esLang
};
addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.pl.data);
addLocaleData(AppLocale.es.data);

// Importing a moment locale also makes it the global one; start from English and let
// the app switch it with the interface language (see containers/App).
moment.locale('en');

export default AppLocale;
